// extracted by mini-css-extract-plugin
module.exports = {"typeName":"RequestTypesTable_typeName__1AJJP","icon":"RequestTypesTable_icon__1dQ6_","inlineWrap":"RequestTypesTable_inlineWrap__1P-Hl"};